import { logService } from '@Engage.Core';
import { toUpperCaseFirsLetter, addCustomEventListener } from '@Core/utils/Utils';
import { AppEvents } from '@Core/constants/AppEvents';
class EventsServiceBase {
    constructor(eventsRoot = document) {
        this.eventsRoot = eventsRoot;
        this.subscribers = [];
    }
    init(availableEvents) {
        this.availableEvents = availableEvents;
        this.listenCustomTrackedEvent();
    }
    /**
     * Dispatch an event � mirrors Connext v2 EventsService.dispatch() exactly.
     * If availableEvents is set, wraps data in event class. Otherwise dispatches raw.
     */
    dispatch(eventName, dispatchData, additionalAnaltyicsPayload) {
        let publicEventData = dispatchData;
        let objectName = toUpperCaseFirsLetter(eventName);
        if (this.availableEvents) {
            try {
                if (this.has(this.availableEvents, objectName)) {
                    publicEventData = new this.availableEvents[objectName](dispatchData);
                    if (!publicEventData.isInner()) {
                        publicEventData.dispatchInnerEvent(dispatchData, eventName);
                    }
                }
                else if (this.has(this.availableEvents, 'PublicEvent')) {
                    publicEventData = new this.availableEvents['PublicEvent'](eventName, dispatchData);
                }
            }
            catch (_a) {
                // Fall back to raw data if event class instantiation fails
                publicEventData = dispatchData;
            }
        }
        logService.log("Fire Default " + eventName + " event. EventData:", publicEventData);
        this.subscribers
            .filter((s) => s.eventName === eventName || s.eventName === null)
            .map((s) => s.handler)
            .forEach((handler) => {
            try {
                handler(publicEventData, eventName);
            }
            catch (ex) {
                logService.warn(ex);
            }
        });
        this.eventsRoot.dispatchEvent(new CustomEvent(eventName, { detail: publicEventData }));
        if (publicEventData && typeof publicEventData.trackEvent === 'function') {
            publicEventData.trackEvent(eventName, dispatchData, additionalAnaltyicsPayload);
        }
    }
    /**
     * @param eventName - pass 'null' to add event handler for all of event types
     * @param handler
     * @param unsubscribe - should unsubscribe on re-run
     * @returns deregistration function
     */
    subscribe(eventName, handler, unsubscribe = false) {
        if (eventName == null) {
            return () => { };
        }
        const eventNames = Array.isArray(eventName)
            ? eventName
            : [eventName];
        this.subscribers = this.subscribers.concat(eventNames.map((eventName) => ({ eventName, handler, unsubscribe })));
        return () => {
            this.subscribers = this.subscribers.filter((s) => s.handler !== handler);
        };
    }
    unsubscribeAll(includeUnsubscribe = false) {
        this.subscribers = this.subscribers.filter((s) => s.unsubscribe && !includeUnsubscribe);
    }
    /**
     * Listens to any event with CustomTrackedEvent name dispatched on the document.
     */
    listenCustomTrackedEvent() {
        addCustomEventListener(document, AppEvents.CustomTrackedEvent, (e) => {
            if (this.availableEvents && this.availableEvents['CustomTrackedEvent']) {
                new this.availableEvents['CustomTrackedEvent'](e);
            }
        });
    }
    has(obj, key) {
        return obj != null && Object.prototype.hasOwnProperty.call(obj, key);
    }
}
const eventsService = new EventsServiceBase();
export default eventsService;
